import React, { Component } from 'react';
import spinner from './images/spinner.gif';
import './console.css';
import DEVICE_TYPE from '../enum/device_type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EVENT_TYPES from '../common/event-type';
import LOCATION_TYPE_ID from '../enum/location_type';
import pendingIcon from '../iLocal-Delivery-Icons/Mail.svg';
import counterIcon from '../iLocal-Delivery-Icons/Counter.svg';
import kioskIcon from '../iLocal-Delivery-Icons/Kiosk.svg';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import bedsideIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArrivedNotification from './notificationsound';
import 'react-calendar/dist/Calendar.css';
import Logo from './images/logo.png';
// import PrintTemplate from 'react-print';
import LabelTemplate from './labelTemplate';
import io from 'socket.io-client';
import NumberFormat from 'react-number-format';
import PropTypes from "prop-types";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { withStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box'
import { AppBar, Menu, Toolbar, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccountCircle from '@mui/icons-material/AccountCircleOutlined';

const deliveryType = [
  { id: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500', label: 'Kiosk' },
  { id: '93d79d62-523a-4d4f-851f-6866d38cb340', label: 'Courier' },
  { id: '40a40496-1c2a-4f46-b00a-f210d34f24cd', label: 'Curbside' },
  { id: '7e8e5632-6187-4d9b-9528-adf14825e859', label: 'InPatient' },
  { id: '567c43b9-dd50-4dd0-b293-2f8ebceb035c', label: 'Counter' },
];

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    padding: theme.spacing.unit * 2,
    height: '100%',
    color: theme.palette.text.secondary,
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    margin: `${theme.spacing.unit * 4}px 0 ${theme.spacing.unit * 2}px`,
  },
  primaryButton: {
    background: 'rgb(4, 166, 225)',
    color: '#fff',
    '&:hover': {
      background: 'rgb(4, 166, 225)',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
 },
 onAmoutDueEditPrimaryButton: {
  background: 'none',
  color: 'rgba(0, 0, 0, 0.54)',
 '&:hover': {
     background: 'rgb(4, 166, 225)',
     color: '#fff',
   },
 },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={"."}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class Console extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      page: 0,
      rowsPerPage: 10,
      pendingDelivery: [],
      kioskData: [],
      courierData: [],
      bedSideData: [],
      curbSideData: [],
      counterData: [],
      kioskPage: 0,
      counterPage: 0,
      courierPage: 0,
      bedsidePage: 0,
      curbsidePage: 0,
      searchText: '',
      scanText: '',
      loader: false,
      scanTextError: false,
      popupData: [],
      open_Move: false,
      fromType: '',
      toType: 'Kiosk',
      selectedTypeId: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
      id: '',
      customer_id: '',
      box_id: '',
      pucode: '',
      disableMove: false,
      type_id: '',
      deletepopup: false,
      items: [],
      rowsPerPagePending: 10,
      rowPerPageCounter: 10,
      rowsPerPageCourier: 10,
      rowsPerPageCurbside: 10,
      rowPerPageInPatient: 10,
      rowPerPageInKiosk: 10,
      hasMore: true,
      hasMoreCounter: true,
      hasMoreKiosk: true,
      hasMoreCurbside: true,
      hasMoreCourier: true,
      hasMoreInpatient: true,
      totalCount: [],
      totalCountCounter: [],
      selectedDate: null,
      anchorEl: null,
      auth: true,
      blockInitialNotificationSound: true,
      index: null,
      printDialogOpen: false
    };
    this.consoleRequest = {
      pageNo: {
        pendingDelivery: 1,
        counter: 1,
        kiosk: 1,
        courier: 1,
        curbside: 1,
        bedside: 1,
      },
      pageSize: {
        pendingDelivery: 10,
        counter: 10,
        kiosk: 10,
        courier: 10,
        curbside: 10,
        bedside: 10,
      },
      scanText: '',
      searchText: '',
      sortColumn: 'created_on',
      sortOrder: 'desc',
      isKaktus: false,
    };
  };

  signOut = () => {
    this.socket && this.socket.disconnect();
    window.location = '/';
    localStorage.clear();
    sessionStorage.clear();
  }

  initSocket = async () => {
    const user = sessionStorage.getItem('user');
    if (!this.socket && user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${
              JSON.parse(user).signInUserSession.idToken.jwtToken
            }`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            this.signOut();
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });

      /**
       ** Socket Console Event Starts **
       */
      this.socket &&
        this.socket.on('console', async (res) => {
          this.setState({
            counterData: [],
            pendingDelivery: [],
            kioskData: [],
            courierData: [],
            curbSideData: [],
            bedSideData: [],
          });
          await this.checkNotification(res.counter, 'totalCountCounter');
          await this.checkNotification(res.curbside, 'totalCount');
          this.setState({
            loader: false,
            counterData: res.counter,
            pendingDelivery: res.pendingDelivery,
            kioskData: res.kiosk,
            courierData: res.courier,
            curbSideData: res.curbside,
            bedSideData: res.bedside,
            blockInitialNotificationSound: false,
          });
        });

      this.socket &&
        this.socket.on('counter', async (res) => {
          this.setState({
            loader: false,
            counterData: res,
          });
          await this.checkNotification(res.counter, 'totalCountCounter');
        });

      this.socket &&
        this.socket.on('pendingDelivery', (res) => {
          this.setState({
            loader: false,
            pendingDelivery: res,
          });
        });

      this.socket &&
        this.socket.on('kiosk', (res) => {
          this.setState({
            loader: false,
            kioskData: res,
          });
        });

      this.socket &&
        this.socket.on('courier', (res) => {
          this.setState({
            loader: false,
            courierData: res,
          });
        });

      this.socket &&
        this.socket.on('curbside', async (res) => {
          this.setState({
            loader: false,
            curbSideData: res,
          });
          await this.checkNotification(res.curbside, 'totalCount');
        });

      this.socket &&
        this.socket.on('bedside', (res) => {
          this.setState({
            loader: false,
            bedSideData: res,
          });
        });

      this.socket &&
      this.socket.on('changesOnConsole', () => {
        console.log('changesOnConsole event emitted!');
        this.consoleRequest &&
          this.socket &&
          this.socket.emit('getConsole', this.consoleRequest);
      });
    }
  };

  checkNotification = async (res, type) => {
    if (this.state.blockInitialNotificationSound) {
      if (res && res.results && res.results.length > 0) {
        let arrivedData = res.results.filter(
          (val) => val.type_id === DEVICE_TYPE.Arrived
        );
        this.setState({ [type]: arrivedData });
      }
    } else {
      if (res && res.results && res.results.length > 0) {
        let arrivedData = res.results.filter(
          (val) => val.type_id === DEVICE_TYPE.Arrived
        );
        if (arrivedData.length > this.state[type].length) {
          this.setState({ [type]: arrivedData }, () => {
            this.playNotification();
          });
        }
      }
    }
  };

  async componentDidMount() {
    !this.socket && (await this.initSocket());
    console.log(`this.consoleRequest`, this.consoleRequest);
    this.socket &&
      this.socket.emit('getConsole', this.consoleRequest) &&
      this.setState({ loader: true });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.socket && this.socket.disconnect();
  }

  playNotification = () => {
    console.log('playNotification');
    // ArrivedNotification.play();
    //e.preventDefault();
    let sound = document.getElementById('curbSound');
    sound.play();
  };

  handleClose = () => {
    this.setState({ open: false });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  handleCloseMove = () => {
    this.setState({ open_Move: false });
  };

  handleMoveOpen = () => {
    console.log('handleMoveOpen');
    this.setState({
      open_Move: true,
      disableMove: true,
      selectedTypeId: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
    });
  };

  handleOpen = (type, obj) => {
    this.setState({ type_id: obj.type_id, index: null });
    if (obj.locationtype_id === LOCATION_TYPE_ID.Kiosk) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Kiosk });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Counter) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Counter });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Courier) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Courier });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Curbside) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Curbside });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.InPatient) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.InPatient });
    }

    if (type === 'kiosk' || obj.DeliveryType === 'Kiosk') {
      this.setState({ disableMove: true });
    } else {
      this.setState({ disableMove: false });
    }
    this.setState({
      fromType: obj.DeliveryType,
      id: obj.id,
      customer_id: obj.customer_id,
      box_id: obj.box_id,
      pucode: obj.pucode,
      loader: true,
    });
    fetch(
      process.env.REACT_APP_BASEURL +
        `deliveryconsole/getdetailsByID/${obj.id}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        this.setState({ popupData: res }, () => {
          this.setState({ open: true, loader: false });
        });
      });
  };

  inputHandler = (type, value) => {
    this.setState({ [type]: value }, () => {
      if (
        this.state.searchText.length > 1 ||
        this.state.searchText.length === 0
      ) {
        this.consoleRequest.searchText = this.state.searchText;
        this.socket && this.socket.emit('getConsole', this.consoleRequest);
      }
    });
  };

  scanHandler = (type, value) => {
    this.setState({ [type]: value }, () => {
      if (
        this.state.scanText.length === 6 ||
        this.state.scanText.length === 0
      ) {
        this.consoleRequest.scanText = this.state.scanText;
        this.socket && this.socket.emit('getConsole', this.consoleRequest);
      }
      if (this.state.scanText.length > 6) {
        this.setState({ scanTextError: true });
      } else {
        this.setState({ scanTextError: false });
      }
    });
  };

  onChangeDeliveyType = (event) => {
    this.setState({ selectedTypeId: event.target.value }, () => {
      let label = deliveryType.filter((val) => {
        if (val.id === this.state.selectedTypeId) {
          return val.label;
        }
        return '';
      });
      this.setState({ toType: label });
      if (
        this.state.selectedTypeId === 'a5bd2ad0-0780-42cd-a270-7e76c4f20500'
      ) {
        this.setState({ disableMove: true });
      } else {
        this.setState({ disableMove: false });
      }
    });
  };

  moveHandler = (type) => {
    this.setState({ loader: true, open_Move: false, open: false });
    let object_id = '';
    let event_type_name = '';
    let type_id = '';
    if (type === 'move') {
      object_id = DEVICE_TYPE.Move;
      event_type_name = EVENT_TYPES.MOVE;
      type_id = this.state.type_id;
    } else if (type === 'deliver') {
      object_id = DEVICE_TYPE.Out_for_Delivery;
      event_type_name = EVENT_TYPES.Out_for_Delivery;
      type_id = object_id;
    } else if (type === 'complete') {
      object_id = DEVICE_TYPE.Completed;
      event_type_name = EVENT_TYPES.COMPLETE;
      type_id = object_id;
    } else if (type === 'return') {
      object_id = DEVICE_TYPE.Returned;
      event_type_name = EVENT_TYPES.RETURN;
      type_id = object_id;
    } else if (type === 'cancel') {
      object_id = DEVICE_TYPE.Cancelled;
      event_type_name = EVENT_TYPES.CANCEL;
      type_id = object_id;
    }
    let user = JSON.parse(sessionStorage.getItem('user'));
    let token =
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken;
    const event_params = {
      event_name: EVENT_CRUD_TYPES.INSERT,
      event_type_name: event_type_name,
      description: `Prescription is moved from ${this.state.fromType} to ${this.state.toType} with pickup code ${this.state.pucode}`,
      object_id: object_id,
      tofor_id: this.state.id,
      box_id: this.state.box_id,
      authorization: token,
      customer_id: this.state.customer_id,
      location_type_id: this.state.selectedTypeId,
      type_id: type_id,
      pickup_date:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.pickup_date
          : new Date(),
      order_id:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.id
          : '',
      account_id:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.parent_account_id
          : '',
      location_notes:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.present_location
          : '',
    };
    fetch(process.env.REACT_APP_BASEURL + `deliveryconsole/updatestatus`, {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event_params),
    })
      .then((response) => response.json())
      .then((res) => this.setState({ loader: false }, () => this.socket && this.socket.emit('updateConsole')));
  };

  handleCloseCancel = () => {
    this.setState({ deletepopup: false });
  };

  cancelHandler = () => {
    this.setState({ deletepopup: true });
  };

  cancelHandlerOrder = () => {
    this.setState({ deletepopup: false, open: false });
    this.moveHandler('cancel');
  };

  fetchMoreData = (type) => {
    if (type === 'pending') {
      let total = 0;
      total =
        this.state &&
        this.state.pendingDelivery &&
        this.state.pendingDelivery.results &&
        this.state.pendingDelivery.results.length;
      if (
        total > 0 &&
        this.state.pendingDelivery.results.length <
          this.state.pendingDelivery.total
      ) {
        this.setState({ total: this.state.total + total });
        this.setState(
          { rowsPerPagePending: this.state.rowsPerPagePending + 10 },
          () => {
            this.consoleRequest.pageSize.pendingDelivery = this.state.rowsPerPagePending;
            this.socket &&
              this.socket.emit('getPendingDelivery', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMore: false });
      }
    } else if (type === 'counter') {
      let total = 0;
      total =
        this.state &&
        this.state.counterData &&
        this.state.counterData.results &&
        this.state.counterData.results.length;
      if (
        total > 0 &&
        this.state.counterData.results.length < this.state.counterData.total
      ) {
        this.setState(
          { rowPerPageCounter: this.state.rowPerPageCounter + 10 },
          () => {
            this.consoleRequest.pageSize.counter = this.state.rowPerPageCounter;
            this.socket && this.socket.emit('getCounter', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCounter: false });
      }
    } else if (type === 'kiosk') {
      let total = 0;
      total =
        this.state &&
        this.state.kioskData &&
        this.state.kioskData.results &&
        this.state.kioskData.results.length;
      if (
        total > 0 &&
        this.state.kioskData.results.length < this.state.kioskData.total
      ) {
        this.setState(
          { rowPerPageInKiosk: this.state.rowPerPageInKiosk + 10 },
          () => {
            this.consoleRequest.pageSize.kiosk = this.state.rowPerPageInKiosk;
            this.socket && this.socket.emit('getKiosk', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreKiosk: false });
      }
    } else if (type === 'curbside') {
      let total = 0;
      total =
        this.state &&
        this.state.curbSideData &&
        this.state.curbSideData.results &&
        this.state.curbSideData.results.length;
      if (
        total > 0 &&
        this.state.curbSideData.results.length < this.state.curbSideData.total
      ) {
        this.setState(
          { rowsPerPageCurbside: this.state.rowsPerPageCurbside + 10 },
          () => {
            this.consoleRequest.pageSize.curbside = this.state.rowsPerPageCurbside;
            this.socket && this.socket.emit('getCurbside', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCurbside: false });
      }
    } else if (type === 'courier') {
      let total = 0;
      total =
        this.state &&
        this.state.courierData &&
        this.state.courierData.results &&
        this.state.courierData.results.length;
      if (
        total > 0 &&
        this.state.courierData.results.length < this.state.courierData.total
      ) {
        this.setState(
          { rowsPerPageCourier: this.state.rowsPerPageCourier + 10 },
          () => {
            this.consoleRequest.pageSize.courier = this.state.rowsPerPageCourier;
            this.socket && this.socket.emit('getCourier', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCourier: false });
      }
    } else if (type === 'inpatient') {
      let total = 0;
      total =
        this.state &&
        this.state.bedSideData &&
        this.state.bedSideData.results &&
        this.state.bedSideData.results.length;
      if (
        total > 0 &&
        this.state.bedSideData.results.length < this.state.bedSideData.total
      ) {
        this.setState(
          { rowPerPageInPatient: this.state.rowPerPageInPatient + 10 },
          () => {
            this.consoleRequest.pageSize.bedside = this.state.rowPerPageInPatient;
            this.socket && this.socket.emit('getBedside', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreInpatient: false });
      }
    }
  };

  printTemplete = async () => {
    this.setState({ printDialogOpen: true });
    setTimeout(async () => {
      window.print();
      this.setState({ printDialogOpen: false });
    }, 100);
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseMenu = () => {
    //window.location.href = `/`;
    this.setState({ anchorEl: null });
  };

  reminderHandler = () => {
    this.setState({ open: false, loader: true });
    let data = {
      order_id: this.state.popupData.id,
      account_id: this.state.popupData.parent_account_id,
      location_type_id: this.state.popupData.locationtype_id,
    };

    fetch(process.env.REACT_APP_BASEURL + 'delivery/remindnotification', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => this.setState({ loader: false }, () => this.socket && this.socket.emit('updateConsole')))
      .catch((error) => {
        console.log('error', error);
        this.setState({ loader: false });
      });
  };

  getOrdersDueAmount = () => {
    const { popupData } = this.state;
    let amount = 0;
    if(popupData && popupData.items && popupData.items.length > 0){
      for (let i = 0; i < popupData.items.length; i++) {
        let due = parseFloat(popupData.items[i].price);
        amount = amount + due;
      }
    }
    return `$${amount.toFixed(2)}`;
  }

  RenderAmountLayout = () => {
    const { popupData } = this.state;
    const style = {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '0.75rem',
      fontWeight: 500,
      textAlign: 'right',
      borderBottom: 'none',
      padding: '4px 25px 4px 24px !important',
      width: '86%'
    };
    return(
      <div>
        <Table aria-labelledby="tableTitle">
          <TableRow style={{ height: 40 }}>
             <TableCell style={style}>Amount Total</TableCell>
             <TableCell style={{ textAlign: 'left' }}>
              {this.getOrdersDueAmount()}
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 40 }}>
             <TableCell style={style}>Amount Due</TableCell>
             <TableCell style={{ textAlign: 'left' }}>
             {popupData && popupData.amount && popupData.amount.isPaid === false
              ? this.getOrdersDueAmount()
              : `$${(0).toFixed(2)}`
             }
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 40 }}>
             <TableCell style={style}>Paid</TableCell>
             <TableCell style={{ textAlign: 'left' }}>
             {popupData && popupData.amount && popupData.amount.isPaid === true
                ? this.getOrdersDueAmount()
                : `$${(0).toFixed(2)}`
              }
            </TableCell>
          </TableRow>
        </Table>
      </div>
    )
  };

  handleChangeDueAmount = (id, type ,value) => {
    if(type === 'price'){
      this.setState(prevState => ({
          popupData: {
            ...prevState.popupData,
            items: [
              ...prevState.popupData.items.map((item) => {
              if(item.id === id){
                return { ...item, price: parseFloat(value)}
              }
              return item;
             })
            ]
          }
      }))
    }
  };

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ index });
  };

  handleUpdateDueAmount = (index, id) => {
    this.setState({ index: Math.random() || index, open: false });
    const { popupData } = this.state;
    const items = popupData && popupData.items && popupData.items.length && popupData.items.find(x => x.id === id);
    this.updateOrderDueAmount(id, items['price']);
  };

  updateOrderDueAmount = (orderid, dueAmount) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    }
    try{
      fetch(process.env.REACT_APP_BASEURL + "updateorderdueamout", {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession
              .idToken.jwtToken,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(updateParams)
      })
      .then((response) => {
        try{
          return response.json()
        }catch(error){
          return null;
        }
      })
      .then((res) => {
        this.setState({ loader: false });
     })
    }catch(error){
      this.setState({ loader: false });
      console.log(error);
    }
  };

  compare = (a, b) => {
    let comparison = 0;
    if(a.type_id === DEVICE_TYPE.Arrived && a.is_paid === true){
      const typeIdA = a && a.type_id.toUpperCase();
      const typeIdB = b && b.type_id.toUpperCase();
      if(typeIdA > typeIdB){
        comparison = -1;
      }else if (typeIdA < typeIdB){
        comparison = 1;
      }
    }
    if(a.is_paid === true){
      const typeIdA = a && a.is_paid;
      const typeIdB = b && b.is_paid;
      if(typeIdA > typeIdB){
        comparison = -1;
      }
      else if(typeIdA < typeIdB){
        comparison = 1;
      }
    }
    return comparison;
  }

  getPatientMRN = (value) => {
    if(value !== '' && value !== 'null' && value !== null && value !== undefined && value !== 'undefined'){
      return value;
    }
    return '';
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    let deletepopup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'xs'}
          open={this.state.deletepopup}
          onClose={this.handleCloseCancel}>
          <DialogTitle id='scroll-dialog-title'>
            <span style={{ color: '#423e3e', fontSize: '1.1rem' }}>
              Are you sure you want to cancel this order? This will remove it
              from the console completely.
            </span>
          </DialogTitle>
          <DialogContent
            sx={{ display: 'flex', justifyContent: 'space-between', mt:'2%' }}>
            <Button
              color='primary'
              onClick={() => this.cancelHandlerOrder()}
              className={classes.primaryButton}
              sx={{minWidth: '100px', minHeight:'43px'}}>
              Yes
            </Button>
            <Button
              color='primary'
              onClick={() => this.handleCloseCancel()}
              className={classes.primaryButton}
              sx={{minWidth: '100px', minHeight:'43px'}}>
              No
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    );

    let popup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={this.state.open}
          onClose={this.handleClose}>
          <DialogTitle id='scroll-dialog-title' sx={{ textAlign: 'center' }}>
            <span className="title">Take Action</span>
            <Tooltip title="Cancel">
              <IconButton aria-label="Cancel" onClick={this.handleClose} style={{marginTop: '-8px', float:'right'}}
                 sx={() => ({ '&:hover': { backgroundColor: 'rgb(4, 166, 225)', color: '#fff' } })}>
                  <CloseIcon />
              </IconButton>
            </Tooltip>
          </DialogTitle>
          <DialogContent>
            {this.state.popupData !== '' &&
            this.state.popupData !== undefined &&
            this.state.popupData !== 'undefined' ? (
              <Grid container>
                <Grid item xs={3} className='font-style'>
                  Pickup Code
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.pucode}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  Patient Name
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.first_name +
                      ' ' +
                      this.state.popupData.last_name}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}} >
                  Phone Number
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.phone}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  Email
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.email}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  Storage Location
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.storage_location}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  Location Notes
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.location_notes}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  Patient Notes
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.patient_notes}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  Order Notes
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.order_notes}
                </Grid>
                {this.state.popupData !== '' &&
                this.state.popupData.present_location !== null &&
                this.state.popupData.present_location !== 'null' &&
                this.state.popupData.present_location !== undefined &&
                this.state.popupData.present_location !== 'undefined' ? (
                  <Grid container>
                    <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                      Patient Order Notes
                    </Grid>
                    <Grid item xs={3} sx={{mt: '2%'}}>
                      {this.state.popupData.present_location}
                    </Grid>
                    <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                      Signature
                    </Grid>
                    <Grid item xs={3} sx={{mt: '2%'}}>
                      {this.state.popupData !== '' &&
                      this.state.popupData !== undefined &&
                      this.state.popupData !== 'undefined' &&
                      this.state.popupData.signature_url ? (
                        <img
                          src={this.state.popupData.signature_url}
                          alt='noimage'
                          style={{ width: '100px' }}
                        />
                      ) : (
                        ''
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  ''
                )}
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  Stock Code
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.stock_code}
                </Grid>
                <br />
                <br />
              </Grid>
            ) : (
              ''
            )}
            <Table class='fixed_headers' style={{marginTop:'3%'}}>
              <TableHead className='thead'>
                <TableRow className='row-height'>
                  <TableCell align='left' scope='row'>Rx Number</TableCell>
                  <TableCell align='left' scope='row'>Drug Name</TableCell>
                  <TableCell align='left' scope='row'>NDC Code</TableCell>
                  <TableCell align='left' scope='row'>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className='tbody-pops' >
                {this.state.popupData !== null &&
                this.state.popupData !== '' &&
                this.state.popupData !== undefined &&
                this.state.popupData !== 'undefined'
                  ? this.state.popupData.items &&
                    this.state.popupData.items.length > 0 &&
                    this.state.popupData.items.map((val, index) => {
                      return (
                        <TableRow key={val.id} className='row-height'>
                          <TableCell component='th' scope='row' align='left'>
                            {val.rx_no}
                          </TableCell>
                          {/* <TableCell className="remove-padding" align="right" >{val.stock_code}</TableCell> */}
                          <TableCell align='left'>{val.drug_name}</TableCell>
                          <TableCell align='left'>{val.ndc_code}</TableCell>
                          <TableCell align='left'>
                            {this.state.index !== index && '$' + val.price.toFixed(2)}
                            {this.state.popupData.amount.isPaid === false ?
                             this.state.index === index ?
                              <React.Fragment>
                                  <TextField
                                      style = {{ width: '60px' }}
                                      value={parseFloat(val.price)}
                                      onChange={(e) => this.handleChangeDueAmount(val.id, 'price', e.target.value)}
                                      id="price"
                                      InputProps={{
                                          inputComponent: NumberFormatCustom,
                                          autocomplete: 'new-password',
                                          form: {
                                              autocomplete: 'off',
                                          },
                                          }}
                                        variant='standard'
                                      />
                                      <Tooltip title="Save">
                                      <IconButton
                                       sx={{ ml: '5%' }}
                                       onClick={() => this.handleUpdateDueAmount(index, val.id)}
                                       className={classes.onAmoutDueEditPrimaryButton}>
                                           <SaveIcon />
                                       </IconButton>
                                      </Tooltip>
                               </React.Fragment>
                               :
                                 <Tooltip title="Edit">
                                    <IconButton
                                     className={classes.onAmoutDueEditPrimaryButton}
                                     onClick={() => this.handleOpenDueAmountEditInput(index)}
                                     sx={{ ml: '10%' }}>
                                        <EditIcon />
                                    </IconButton>
                                 </Tooltip>
                            : ('')}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : ''}
              </TableBody>
            </Table>
            <br />
            {this.RenderAmountLayout()}
            <div style={{ marginTop: '2%' }}>
              <Grid container style={{ justifyContent: 'space-evenly' }}>
                <Button
                  color='primary'
                  onClick={() => this.printTemplete()}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Print
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.reminderHandler('deliver')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Remind
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('deliver')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Deliver
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('complete')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Complete
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('return')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Return
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.handleMoveOpen()}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Move
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.cancelHandler()}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  Cancel
                </Button>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

    let movePopup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={this.state.open_Move}
          onClose={this.handleCloseMove}>
          <DialogTitle id='scroll-dialog-title' style={{ textAlign: 'center' }}>
            <span>Move Action</span>
            <Tooltip title="Cancel">
              <IconButton aria-label="Cancel"
               onClick={this.handleCloseMove}
               style={{marginTop: '-8px', float:'right'}}
                sx={() => ({ '&:hover': { backgroundColor: 'rgb(4, 166, 225)', color: '#fff' } })}>
                  <CloseIcon />
              </IconButton>
            </Tooltip>
          </DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid item xs={3} className='font-style'>
                Pickup Code
              </Grid>
              <Grid item xs={3}>
                {this.state.popupData !== '' &&
                  this.state.popupData !== undefined &&
                  this.state.popupData !== 'undefined' &&
                  this.state.popupData.pucode}
              </Grid>
              <Grid item xs={3} className='font-style'>
                Name
              </Grid>
              <Grid item xs={3}>
                {this.state.popupData !== '' &&
                  this.state.popupData !== undefined &&
                  this.state.popupData !== 'undefined' &&
                  this.state.popupData.first_name +
                    ' ' +
                    this.state.popupData.last_name}
              </Grid>
            </Grid>
            <div className={classes.root}>
              {this.state.loader ? (
                <div className={classes.spinner}>
                  <img
                    className={classes.spinnerImage}
                    src={spinner}
                    alt='loading'
                  />
                </div>
              ) : null}
            </div>
            <br />
            <Table class='fixed_headers'>
              <TableHead className='thead'>
                <TableRow className='row-height'>
                  <TableCell className='remove-padding'>From</TableCell>
                  <TableCell className='remove-padding' align='left'>
                    To
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{height: '55px'}}>
                  <TableCell
                    component='th'
                    scope='row'
                    className='remove-padding'>
                    {this.state.fromType}
                  </TableCell>
                  <TableCell>
                    <FormControl sx={{width: '28ch'}}>
                      <Select
                        value={this.state.selectedTypeId}
                        onChange={(event) => this.onChangeDeliveyType(event)}
                        variant='standard'>
                        {deliveryType.map((box, index) => (
                          <MenuItem key={index} value={box.id} selected sx={{height: '46px'}}>
                            {box.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <br />
            <Grid
              container
              style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                color='primary'
                onClick={() => this.moveHandler('move')}
                disabled={this.state.disableMove}
                className={classes.primaryButton}
                sx={{minWidth: '100px', minHeight:'43px'}}>
                Move
              </Button>
              <Button
                onClick={this.handleCloseMove}
                color='primary'
                className={classes.primaryButton}
                sx={{minWidth: '100px', minHeight:'43px'}}>
                Close
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );

    return (
      <div>
       <div id='react-no-print'>
        <AppBar position='absolute' style={{ backgroundColor: '#04A6E1' }}>
          <Toolbar disableGutters>
            <div>
              <img
                src={Logo}
                alt='Kaktus Logo'
                style={{ height: 70, width: 150 }}
              />
            </div>
            <Box sx={{ position: 'absolute', right: '1%', display: 'flex' }} component='div'>
              <Box component='span' sx={{ p: '1px', mr: '5px', pt: '10px'}}>
               <IconButton
                aria-owns={open ? 'menu-appbar' : null}
                aria-label='account of current user'
                aria-controls='menu-appbar'
                aria-haspopup='true'
                onClick={this.handleMenu}
                color='inherit'
                sx={{ '.MuiSvgIcon-root': { fontSize: '2rem' }}}>
                <AccountCircle/>
               </IconButton>
               </Box>
              <Box component='span' sx={{ pt: '10px'}}>
                {JSON.parse(sessionStorage.getItem('user')) &&
                JSON.parse(sessionStorage.getItem('user')).signInUserSession ? (
                  <Box component='div' sx={{ textAlign: 'left' }}>
                    <p style={{ fontSize: 15, margin: 0, fontWeight: 500 }}>
                    {sessionStorage.getItem('parentAccountName')}
                    </p>
                    <p style={{ fontSize: 14, marginTop: 0, fontWeight: 400 }}>
                    {
                        JSON.parse(sessionStorage.getItem('user'))
                        .signInUserSession.idToken.payload.name
                      }
                    </p>
                  </Box>
                ) : (
                  setTimeout(
                    () => this.props.navigate('/', { replace: true }),
                    0
                  )
                )}
              </Box>
              <Menu
                id='menu-appbar'
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleCloseMenu}>
                <MenuItem onClick={this.signOut}>Logout</MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
        <div style={{ padding: '5px' }}>
        <div id='react-no-print'>
          {popup}
          {movePopup}
          {deletepopup}
          <ArrivedNotification />
          <Box className={classes.root} component='div'>
            {this.state.loader ? (
              <div className={classes.spinner}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt='loading'
                />
              </div>
            ) : null}
          </Box>
          <Box sx={{ p: 1, display: 'flex', ml: '4px', mt: '4%' }}>
            <Box>
              <TextField
                label='Search'
                className='text-width'
                InputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                variant="standard"
                onChange={(event) =>
                  this.inputHandler('searchText', event.target.value)
                }
                style={{ width: '35ch' }}
              />
            </Box>
            <Box sx={{ ml: '20px'}}>
              <TextField
                label='Scan'
                className='text-width'
                error={this.state.scanTextError}
                helperText={
                  this.state.scanTextError
                    ? 'Please Enter Valid stock code'
                    : ''
                }
                onChange={(event) =>
                  this.scanHandler('scanText', event.target.value)
                }
                InputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                variant="standard"
                style={{ width: '35ch' }}
              />
            </Box>
          </Box>
          <Grid container xs={12}>
            <Grid item className='card-pos' sm={4} xs={4} md={4} lg={4} xl={4}>
              <Card sx={{ height: 450, position: 'relative' }}>
                <Grid container sx={{ marginBottom: '-6%' }}>
                  <Grid item xs={8} sx={{mt: '10px'}}>
                    <span className='pending'>Pending Deliveries</span>
                  </Grid>
                  <Grid item xs={2} sx={{mt: '-5px'}}>
                    <img src={pendingIcon} alt='Icon' className='pendingIcon'/>
                  </Grid>
                  <Grid item xs={2} className='count-position'>
                    <CardHeader sx={{pr:'30px', mt:'5px'}}
                      title={
                        this.state.pendingDelivery &&
                        this.state.pendingDelivery.total > 0
                          ? this.state.pendingDelivery.total
                          : 0
                      }
                    />
                  </Grid>
                </Grid>
                <CardContent>
                  {this.state.pendingDelivery &&
                  this.state.pendingDelivery.total === 0 ? (
                    <div>
                      <Grid container className='noDataFound'>
                        <Grid item xs={8}>
                          <span>No Data Found</span>
                        </Grid>
                      </Grid>
                    </div>
                  ) : (
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader full-name'>
                              Full Name
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              PU Code
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              Delivery Type
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              Destination Location
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowsPerPagePending}
                          next={() => this.fetchMoreData('pending')}
                          hasMore={this.state.hasMore}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.pendingDelivery &&
                              this.state.pendingDelivery.results
                                ? this.state.pendingDelivery.results.map(
                                    (val) => {
                                      return (
                                        <TableRow
                                          key={val.id}
                                          className='row-height'>
                                          <TableCell
                                            component='th'
                                            scope='row'
                                            align='left'
                                            className='remove-padding' sx={{ fontSize: '0.8125rem' }}>
                                              <Box component='p' sx={{mt:0, mb:0}}>
                                              {val.first_name +
                                              ' ' +
                                              val.last_name}
                                              </Box>
                                              <Box component='p' sx={{mt:'4px', mb:'4px'}}>{val.dob_str}</Box>
                                              <Box component='p' sx={{mt:0, mb:0}}>{this.getPatientMRN(val.patient_id)}</Box>
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding pucode'
                                            align='left'
                                            onClick={() =>
                                              this.handleOpen('pending', val)
                                            } sx={{ fontSize: '0.8125rem' }}>
                                            {val.pucode}
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding'
                                            align='left' sx={{ fontSize: '0.8125rem' }}>
                                            {val.DeliveryType}
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding'
                                            align='left' sx={{ fontSize: '0.8125rem' }}>
                                            {val.destination_location}
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding'
                                            align='center' sx={{ fontSize: '0.8125rem' }}>
                                            {val.type_id === DEVICE_TYPE.Ready
                                              ? 'Ready'
                                              : val.type_id ===
                                                DEVICE_TYPE.Out_for_Delivery
                                              ? 'Out for Delivery'
                                              : val.type_id ===
                                                DEVICE_TYPE.Arrived
                                              ? 'Arrived'
                                              : val.type_id ===
                                                DEVICE_TYPE.Stocked
                                              ? 'Stocked'
                                              : val.type_id ===
                                                DEVICE_TYPE.Return
                                              ? 'Return'
                                              : val.type_id ===
                                                DEVICE_TYPE.Cancelled
                                              ? 'Cancelled'
                                              : val.type_id ===
                                                DEVICE_TYPE.Completed
                                              ? 'Completed'
                                              : val.type_id ===
                                                DEVICE_TYPE.Assigned
                                              ? 'Assigned'
                                              : ''}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
            {this.state.counterData && this.state.counterData.total > 0 ? (
              <Grid item className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={8} sx={{mt: '10px'}}>
                      <span className='counter'>Counter</span>
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={counterIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.counterData &&
                          this.state.counterData.total > 0
                            ? this.state.counterData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader'>
                              Full Name
                            </TableCell>
                            <TableCell className='tableHeader'>
                              PU Code
                            </TableCell>
                            <TableCell className='tableHeader'>
                              Co-Pay
                            </TableCell>
                            <TableCell className='tableHeader'>
                              Signature
                            </TableCell>
                            <TableCell
                              className='tableHeader'
                             >
                              Storage Location
                            </TableCell>
                            <TableCell className='tableHeader'>
                              Patient Notes
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowPerPageCounter}
                          next={() => this.fetchMoreData('counter')}
                          hasMore={this.state.hasMoreCounter}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.counterData &&
                              this.state.counterData.results
                                ? this.state.counterData.results.sort(this.compare).map((val) => {
                                    let color =
                                      val.type_id &&
                                      val.type_id === DEVICE_TYPE.Arrived && val.is_paid === true
                                        ? `style-row-counter`
                                        : val.is_paid === true
                                        ? `style-row-counter-blue`
                                        : '';
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className={`row-height ${color}`}
                                       >
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{ fontSize: '0.8125rem'}}>
                                           <Box component='p' sx={{mt:0, mb:0}}>{val.first_name + ' ' + val.last_name}</Box>
                                           <Box component='p' sx={{mt:'4px', mb:'4px'}}>{val.dob_str}</Box>
                                           <Box component='p' sx={{mt:0, mb:0}}>{this.getPatientMRN(val.patient_id)}</Box>
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('counter', val)
                                          }
                                          style={{ fontSize: '0.8125rem'}}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell className='remove-padding' align='left' style={{ fontSize: '0.8125rem', ...val.is_paid ? { color: 'black' } : { color: 'red' }}}>
                                          {val.is_paid ? 'Paid' : 'Due'}
                                        </TableCell>
                                        <TableCell className='remove-padding' align='left'  style={{ fontSize: '0.8125rem'}}>
                                          {val.signature_url !== '' && val.signature_url !== null && val.signature_url !== 'null' && val.signature_url !== undefined && val.signature_url !== 'undefined' ? 'Done' : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'  style={{ fontSize: '0.8125rem'}}>
                                          {val.storage_location !== null &&
                                          val.storage_location !== 'null' &&
                                          val.storage_location !== undefined &&
                                          val.storage_location !== 'undefined'
                                            ? val.storage_location
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem'}}>
                                          {val.notes !== null &&
                                          val.notes !== 'null' &&
                                          val.notes !== undefined &&
                                          val.notes !== 'undefined'
                                            ? val.notes
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' style={{ fontSize: '0.8125rem'}}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.counterData &&
                      this.state.counterData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>No Data Found</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.kioskData && this.state.kioskData.total > 0 ? (
              <Grid item className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={8} sx={{mt: '10px'}}>
                      <span className='kiosk'>Kiosk</span>
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img src={kioskIcon} alt='Icon' className='pendingIcon' />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.kioskData && this.state.kioskData.total > 0
                            ? this.state.kioskData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader full-name'>
                              Full Name
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              PU Code
                            </TableCell>
                            <TableCell
                              className='tableHeader full-name'
                            >
                              Box Name
                            </TableCell>
                            <TableCell className='tableHeader'>
                              Stock Code
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowPerPageInKiosk}
                          next={() => this.fetchMoreData('kiosk')}
                          hasMore={this.state.hasMoreKiosk}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.kioskData &&
                              this.state.kioskData.results
                                ? this.state.kioskData.results.map((val) => {
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className='row-height'>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'
                                          >
                                           <Box component='p' sx={{mt:0, mb:0}}>{val.first_name + ' ' + val.last_name}</Box>
                                           <Box component='p' sx={{mt:'4px', mb:'4px'}}>{val.dob_str}</Box>
                                           <Box component='p' sx={{mt:0, mb:0}}>{this.getPatientMRN(val.patient_id)}</Box>
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('kiosk', val)
                                          }
                                          sx={{ fontSize: '0.8125rem' }}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' sx={{ fontSize: '0.8125rem' }}>
                                          {val.name}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' sx={{ fontSize: '0.8125rem' }}>
                                          {val.stock_code}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' sx={{ fontSize: '0.8125rem' }}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : val.type_id ===
                                              DEVICE_TYPE.Assigned
                                            ? 'Assigned'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.kioskData &&
                      this.state.kioskData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>No Data Found</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.curbSideData && this.state.curbSideData.total > 0 ? (
              <Grid item className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={8} sx={{mt: '10px'}}>
                      <span className='curbside'>Curb Side</span>
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={curbsideIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.curbSideData &&
                          this.state.curbSideData.total > 0
                            ? this.state.curbSideData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell
                             className='tableHeader full-name'
                             >
                              Full Name
                            </TableCell>
                            <TableCell
                             className='tableHeader'
                             align='left'
                             >
                              PU Code
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            >
                              Co-Pay
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            >
                              Signature
                            </TableCell>
                            <TableCell
                              className='tableHeader'
                              >
                              Storage Location
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            >
                              Patient Notes
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='center'
                            >
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowsPerPageCurbside}
                          next={() => this.fetchMoreData('curbside')}
                          hasMore={this.state.hasMoreCurbside}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.curbSideData &&
                              this.state.curbSideData.total > 0
                                ? this.state.curbSideData.results.sort(this.compare).map((val) => {
                                  let color =
                                      val.type_id &&
                                      val.type_id === DEVICE_TYPE.Arrived && val.is_paid === true
                                        ? `style-row-counter`
                                        : val.is_paid === true
                                        ? `style-row-counter-blue`
                                        : '';
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className={`row-height ${color}`}>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding' style={{ fontSize: '0.8125rem' }}>
                                            <Box component='p' sx={{mt:0, mb:0}}>{val.first_name + ' ' + val.last_name}</Box>
                                            <Box component='p' sx={{mt:'4px', mb:'4px'}}>{val.dob_str}</Box>
                                            <Box component='p' sx={{mt:0, mb:0}}>{this.getPatientMRN(val.patient_id)}</Box>
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('curbside', val)
                                          }
                                          style={{ fontSize: '0.8125rem' }}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                        className='remove-padding'
                                        align='left'
                                        style={{ fontSize: '0.8125rem', ...val.is_paid ? {color:'black'} : {color: 'red'}}}>
                                          {val.is_paid ? 'Paid' : 'Due'}
                                        </TableCell>
                                        <TableCell
                                        className='remove-padding'
                                        align='left'
                                        style={{ fontSize: '0.8125rem'}}>
                                          {val.signature_url !== '' && val.signature_url !== null && val.signature_url !== 'null' && val.signature_url !== undefined && val.signature_url !== 'undefined' ? 'Done' : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{fontSize: '0.8125rem'}}>
                                          {val.storage_location !== null &&
                                          val.storage_location !== 'null' &&
                                          val.storage_location !== undefined &&
                                          val.storage_location !== 'undefined'
                                            ? val.storage_location
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem' }} >
                                          {val.notes &&
                                          val.notes !== null &&
                                          val.notes !== 'null' &&
                                          val.notes !== undefined &&
                                          val.notes !== 'undefined'
                                            ? val.notes
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' style={{ fontSize: '0.8125rem' }}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.curbSideData &&
                      this.state.curbSideData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>No Data Found</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.courierData && this.state.courierData.total > 0 ? (
              <Grid item className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={8} sx={{mt: '10px'}}>
                      <span className='courier'>Courier</span>
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={courierIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.courierData &&
                          this.state.courierData.total > 0
                            ? this.state.courierData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader full-name'>
                              Full Name
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              PU Code
                            </TableCell>
                            <TableCell
                              className='tableHeader'
                              >
                              Storage Location
                            </TableCell>
                            <TableCell className='tableHeader'>
                              Patient Notes
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowsPerPageCourier}
                          next={() => this.fetchMoreData('courier')}
                          hasMore={this.state.hasMoreCourier}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='courierbody'
                              >
                              {this.state.courierData &&
                              this.state.courierData.total > 0
                                ? this.state.courierData.results.map((val) => {
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className='row-height'>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'  style={{ fontSize: '0.8125rem' }}>
                                            <Box component='p' sx={{mt:0, mb:0}}>{val.first_name + ' ' + val.last_name}</Box>
                                            <Box component='p' sx={{mt:'4px', mb:'4px'}}>{val.dob_str}</Box>
                                            <Box component='p' sx={{mt:0, mb:0}}>{this.getPatientMRN(val.patient_id)}</Box>
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('courier', val)
                                          }
                                          style={{ fontSize: '0.8125rem' }}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem' }}>
                                          {val.storage_location !== null &&
                                          val.storage_location !== 'null' &&
                                          val.storage_location !== undefined &&
                                          val.storage_location !== 'undefined'
                                            ? val.storage_location
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem' }}>
                                          {val.notes !== '' &&
                                          val.notes !== null &&
                                          val.notes !== 'null' &&
                                          val.notes !== undefined &&
                                          val.notes !== 'undefined'
                                            ? val.notes
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' style={{ fontSize: '0.8125rem' }}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.courierData &&
                      this.state.courierData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>No Data Found</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                      {/* <div style={{ position: 'absolute', bottom: 0, right: 0, left: 0, textAlign: 'center' }}>
                                    <TablePagination
                                        component="div"
                                        count={this.state.courierData && this.state.courierData.total ? this.state.courierData.total : 0}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.courierPage}
                                        backIconButtonProps={{
                                            "aria-label": "Previous Page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "Next Page"
                                        }}
                                        onChangePage={this.handleChangePageCourier}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div> */}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.bedSideData && this.state.bedSideData.total > 0 ? (
              <Grid item className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={8} sx={{mt: '10px'}}>
                      <span className='bedside'>Bedside</span>
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={bedsideIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.bedSideData &&
                          this.state.bedSideData.total > 0
                            ? this.state.bedSideData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell
                             className='tableHeader full-name'
                             >
                              Full Name
                            </TableCell>
                            <TableCell
                             className='tableHeader'
                             align='left'
                             >
                              PU Code
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              Co-Pay
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              Signature
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              Storage Location
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              Patient Notes
                            </TableCell>
                            <TableCell
                             className='tableHeader'
                             align='center'
                             >
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowPerPageInPatient}
                          next={() => this.fetchMoreData('inpatient')}
                          hasMore={this.state.hasMoreInpatient}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.bedSideData &&
                              this.state.bedSideData.total > 0
                                ? this.state.bedSideData.results.sort(this.compare).map((val) => {
                                  let color =
                                      val.type_id &&
                                      val.type_id === DEVICE_TYPE.Arrived && val.is_paid === true
                                        ? `style-row-counter`
                                        : val.is_paid === true
                                        ? `style-row-counter-blue`
                                        : '';
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className={`row-height ${color}`}>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'
                                          style={{fontSize: '0.8125rem'}}>
                                           <Box component='p' sx={{mt:0, mb:0}}>{val.first_name + ' ' + val.last_name}</Box>
                                           <Box component='p' sx={{mt:'4px', mb:'4px'}}>{val.dob_str}</Box>
                                           <Box component='p' sx={{mt:0, mb:0}}>{this.getPatientMRN(val.patient_id)}</Box>
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}
                                          onClick={() =>
                                            this.handleOpen('bedside', val)
                                          }>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{  fontSize: '0.8125rem', ...val.is_paid ? {color: 'black'} : {color: 'red'}}}
                                          >
                                          {val.is_paid ? 'Paid' : 'Due'}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}
                                         >
                                          {val.signature_url !== '' &&
                                            val.signature_url !== null &&
                                             val.signature_url !== 'null' &&
                                              val.signature_url !== undefined &&
                                               val.signature_url !== 'undefined'
                                               ? 'Done'
                                               : ''
                                          }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.storage_location &&
                                            val.storage_location !== '' &&
                                             val.storage_location !== null &&
                                              val.storage_location !== 'null' &&
                                               val.storage_location !== undefined &&
                                                val.storage_location !== 'undefined'
                                                 ? val.storage_location
                                                 : ''
                                          }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.notes &&
                                            val.notes !== null &&
                                             val.notes !== 'null' &&
                                              val.notes !== undefined &&
                                               val.notes !== 'undefined'
                                               ? val.notes
                                               : ''
                                          }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.bedSideData &&
                      this.state.bedSideData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>No Data Found</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </div>
          </div>
        </div>
        <div id="react-no-prrint">
            <div id="react-no-print">
              <Dialog 
                open={this.state.printDialogOpen || false}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  style: { borderRadius: '0px', width: '250px', height: '400px' }
                }}
              >
                <DialogContent style={{padding: '10px' }}>
                <LabelTemplate
                  style={{ display: 'none' }}
                  stockCode={this.state.popupData.stock_code || ''}
                  pickupCode={this.state.popupData.pucode || ''}
                  rxNumbers={
                    this.state.popupData &&
                    this.state.popupData.items &&
                    this.state.popupData.items.length > 0 &&
                    this.state.popupData.items.map((item) => {
                      return item.rx_no;
                    })
                  }
                  boxId={this.state.popupData.box_id || ''}
                  ref={(el) => (this.componentRef = el)}
                  accountDetails={this.state.popupData.accDetails || ''}
                  pharmacyDetails={this.state.popupData.boxDetails || ''}
                  firstName={this.state.popupData.first_name || ''}
                  lastName={this.state.popupData.last_name || ''}
                  prefer_location_name={this.state.popupData.box_name || ''}
                />
                </DialogContent>
              </Dialog>
            </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Console);



// WEBPACK FOOTER //
// ./src/components/console/index.js